const quizContainer = document.getElementById('quiz');
import Vue from 'vue/dist/vue.min.js';
import AOS from 'aos'

function quiz() {
    if (document.body.contains(quizContainer)) {

        // Each Question has the following:
        // ID : This should be the ID for the question
        // Text : This is the Question itself
        // Responses: These are the buttons which the user can click to navigate to the next Q.
        // Text : The button Text
        // Icon : The Icon to display in the button
        // Classes: The classes to use on the button
        // Answer: The ID of the Question that this button will navigate to.

        const quiz = {
            questions: [
                {
                    id: 'a',
                    text: "Is the translation for basic understanding?",
                    responses: [{
                            text: 'Yes',
                            icon: 'icon-thumbs-up',
                            classes: 'button--icon button--quiz',
                            answer: 'e'
                        },
                        {
                            text: 'No',
                            icon: 'icon-thumbs-down',
                            classes: 'button--icon button--quiz',
                            answer: 'b'
                        },
                    ]
                },
                {
                    id: 'b',
                    text: "Is the translation for internal use?",
                    responses: [{
                            text: 'Yes',
                            icon: 'icon-thumbs-up',
                            classes: 'button--icon button--quiz',
                            answer: 'e'
                        },
                        {
                            text: 'No',
                            icon: 'icon-thumbs-down',
                            classes: 'button--icon button--quiz',
                            answer: 'c'
                        },
                    ]
                },
                {
                    id: 'c',
                    text: "Will the translation be published externally?",
                    responses: [{
                            text: 'Yes',
                            icon: 'icon-thumbs-up',
                            classes: 'button--icon button--quiz',
                            answer: 'e-published'
                        },
                        {
                            text: 'No',
                            icon: 'icon-thumbs-down',
                            classes: 'button--icon button--quiz',
                            answer: 'd'
                        },
                    ]
                },
                {
                    id: 'd',
                    text: "Is the translation highly technical?",
                    responses: [{
                            text: 'Yes',
                            icon: 'icon-thumbs-up',
                            classes: 'button--icon button--quiz',
                            answer: 'e-technical'
                        },
                        {
                            text: 'No',
                            icon: 'icon-thumbs-down',
                            classes: 'button--icon button--quiz',
                            answer: 'final-quote'
                        },
                    ]
                },
                {
                    id: 'e',
                    text: "Is the translation over 10,000 words?",
                    responses: [{
                            text: 'Yes',
                            icon: 'icon-thumbs-up',
                            classes: 'button--icon button--quiz',
                            answer: 'f'
                        },
                        {
                            text: 'No',
                            icon: 'icon-thumbs-down',
                            classes: 'button--icon button--quiz',
                            answer: 'f-technical'
                        },
                    ]
                },
                {
                    id: 'e-technical',
                    text: "Is the translation over 10,000 words?",
                    responses: [{
                            text: 'Yes',
                            icon: 'icon-thumbs-up',
                            classes: 'button--icon button--quiz',
                            answer: 'f-technical'
                        },
                        {
                            text: 'No',
                            icon: 'icon-thumbs-down',
                            classes: 'button--icon button--quiz',
                            answer: 'f-technical'
                        },
                    ]
                },
                {
                    id: 'e-published',
                    text: "Is the translation over 10,000 words?",
                    responses: [{
                            text: 'Yes',
                            icon: 'icon-thumbs-up',
                            classes: 'button--icon button--quiz',
                            answer: 'f-published'
                        },
                        {
                            text: 'No',
                            icon: 'icon-thumbs-down',
                            classes: 'button--icon button--quiz',
                            answer: 'f-published'
                        },
                    ]
                },
                {
                    id: 'f',
                    text: "What's most important to you?",
                    responses: [{
                            text: 'Cost',
                            icon: '',
                            classes: 'button--quiz',
                            answer: 'final-a'
                        },
                        {
                            text: 'Quality',
                            icon: '',
                            classes: 'button--quiz',
                            answer: 'final-b'
                        },
                        {
                            text: 'Turnaround',
                            icon: '',
                            classes: 'button--quiz',
                            answer: 'final-a'
                        },
                    ]
                },
                {
                    id: 'f-technical',
                    text: "What's most important to you?",
                    responses: [{
                            text: 'Cost',
                            icon: '',
                            classes: 'button--quiz',
                            answer: 'final-a-technical'
                        },
                        {
                            text: 'Quality',
                            icon: '',
                            classes: 'button--quiz',
                            answer: 'final-b-technical'
                        },
                        {
                            text: 'Turnaround',
                            icon: '',
                            classes: 'button--quiz',
                            answer: 'final-a-technical'
                        },
                    ]
                },
                {
                    id: 'f-published',
                    text: "What's most important to you?",
                    responses: [{
                            text: 'Cost',
                            icon: '',
                            classes: 'button--quiz',
                            answer: 'final-a-technical'
                        },
                        {
                            text: 'Quality',
                            icon: '',
                            classes: 'button--quiz',
                            answer: 'final-b-technical'
                        },
                        {
                            text: 'Turnaround',
                            icon: '',
                            classes: 'button--quiz',
                            answer: 'final-a-technical'
                        },
                    ]
                },
                {
                    id: 'final-quote',
                    message: 'Get a call back within 60 minutes from our friendly, experienced team for a free consultation.'
                },
                {
                    id: 'final-a',
                    services: '<strong>AI</strong> or <strong>Rapid</strong>',
                    query: 'AI or Rapid',
                },
                {
                    id: 'final-b',
                    services: '<strong>Rapid</strong> or <strong>Basic</strong>',
                    query: 'Rapid or Basic',
                },
                {
                    id: 'final-a-technical',
                    services: '<strong>Basic</strong> or <strong>Specialist</strong>',
                    query: 'Basic or Specialist',
                },
                {
                    id: 'final-b-technical',
                    services: '<strong>Branded</strong> or <strong>Creative</strong>',
                    query: 'Branded or Creative',
                },
            ]
        };


        const app = new Vue({
            created () {
                AOS.init({
                    once: true,
                })
            },
            el: '#quiz-questions',
            delimiters: ['${', '}'],
            data: {
                quiz: quiz,
                questionIndex: 0,
            },
            updated: function() {
                this.$nextTick(function () {
                    this.triggerEvent();
                });
            },
            mounted: function() {
                this.$nextTick(function () {
                    this.triggerEvent();
                });
            },
            methods: {
                // Find the Next Question / Final Message based on the ID.
                findRelated(value) {
                    const questions = this.quiz.questions;
                    for(var i=0; i < questions.length; i++){
                        if( questions[i].id == value){
                            this.questionIndex = [i][0];
                        }
                    }
                },
                // Reset the Quiz to the beginning
                resetQuiz() {
                    this.questionIndex = 0;
                    this.triggerEvent();
                },
                // Trigger event when question has loaded
                triggerEvent() {
                    setTimeout(function() {
                        document.getElementById('question-wrapper').classList.add('question-init');
                    }, 1600);
                    setTimeout(function() {
                        document.getElementById('question-wrapper').classList.add('question-loading');
                    }, 1800);
                    setTimeout(function() {
                        document.getElementById('question-wrapper').classList.add('question-loaded');
                    }, 2000);
                }
            },

        });

    }

}


export default quiz;
